import { createButtonNew } from 'src/shared/entities/button/create-button'
import i18n from 'client/i18n'
import { insertChild } from 'src/shared/entities/utils/generate-base-entity'
import { ButtonInterface } from 'common/types/entities/button-interface'
import { BaseEntityWithChildIdsInterface } from 'common/types/entities/EntityInterface'
import { OldEntityWithChildIds } from 'common/types/entities/OldEntityInterface'
import { getDefaultButtonSettings } from 'src/editor/shared/entities/website-header/utils'

export const createWebsiteHeaderButtonFromLibrary = ({
  container,
  locale,
  position = 0,
  options,
  createButton = createButtonNew,
}: {
  container: BaseEntityWithChildIdsInterface | OldEntityWithChildIds
  locale: string
  position?: number
  options?: Partial<ButtonInterface>
  createButton?: typeof createButtonNew
}) => {
  const fixedT = i18n.getFixedT(locale)

  const button = createButton(
    container.id,
    fixedT('entities.button.default_text'),
    '',
    container.masterBlockId,
  )

  return {
    [container.id]: {
      ...container,
      childIds: insertChild(container.childIds, button.id, position),
    },
    [button.id]: {
      ...button,
      ...options,
      ...getDefaultButtonSettings,
    },
  }
}
